import Styled,{css } from 'styled-components'

export const Container = Styled.div`
  color: #00003C !important;
  
  .custom-search {
    input {
      color: #00003C !important;
      margin-bottom: 5px;
      font-family: var(--font-family);
    }
    
    label {
      color: #00003C !important;
      font-size: 1.1rem !important;
      font-family: var(--font-family);
    }
    
    label.Mui-focused {
      color: #00003C !important;
    }
    
    .MuiInput-underline:before {
      border-bottom-color: #00003C !important;
    }
    
    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom-color: #00003C !important;
    }
    
    .MuiInput-underline:after {
      border-bottom-color: #00003C !important;
    }
  }
  
  .input-group-wl {
    color: #00003C !important;
    
    svg {
      color: #00003C !important;
    }
  }
`